<button [id]="id" class="date-range-opener btn btn-primary">
  <i class="far fa-calendar-alt"></i>&nbsp;
  <span>{{description}}</span>&nbsp;
  <i class="fa fa-caret-down"></i>
</button>
